import {
  postGymSpaceRegister,
  usePatchCoachGym,
  usePostCoachGym
} from '#api/gyms';
import { useGetCoordinates } from '#api/location';
import { ImageUpload } from '#assets/svg';
import { Button, Flex, SaveText, Textarea } from '#atoms';
import { KakaoMap } from '#atoms/KakaoMap';
import { AddressModal, LabeledInput } from '#molecules';
import { Strong } from '#pages/OnBoardIntro/styles';
import { useToast } from '#providers/ToastProvider';
import { useUserInfo } from '#providers/UserInfo';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { IPostGymSpaceRegistry, Gym as TGym } from '#types/gyms';
import { useEffect, useState } from 'react';
// import { useForm } from 'react-hook-form';
import { GiTowel } from 'react-icons/gi';
import { IoSearchSharp } from 'react-icons/io5';
import {
  MdDirectionsCar,
  MdOutlineShower,
  MdScreenLockLandscape
} from 'react-icons/md';
import { PiCoatHanger } from 'react-icons/pi';
import { TbShirtFilled } from 'react-icons/tb';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { InputLength } from 'src/shared/components/InputLength';
import { FileUpload } from 'src/shared/components/file-upload/FileUpload';
import styled, { useTheme } from 'styled-components';
import { gymStateAtom } from '../OnBoardStep/components/Step6/Step6.atoms';
import { getMyAccount } from '#api/accounts';

export function OnBoardCreateGym() {
  const [gymState, setGymState] = useRecoilState(gymStateAtom);

  const theme = useTheme();
  // 안 쓰는 코드 주석 처리
  // const [detail, setDetail] = useState('');
  const navigate = useNavigate();

  // mutateAsync: patchCoachGym, 있었음
  const { isLoading } = usePatchCoachGym(gymState?.id ?? '');

  const { mutateAsync: postCoachGym } = usePostCoachGym({
    onSuccess: () => {
      showToast({
        message: '수업 장소가 저장되었습니다.',
        type: 'success'
      });
      getMyAccount().then(account => {
        setUserInfo(account);
        setGymState(account.recommendGyms[0]);
      });
    },
    onError: () => {
      showToast({
        message: '수업 장소를 저장하는데 실패했습니다.',
        type: 'fail'
      });
    }
  });

  const { showToast } = useToast();

  // 안 쓰는 코드 주석 처리
  // const handleEnroll = async () => {
  //   if (!gymState) return;
  //   try {
  //     await patchCoachGym({
  //       status: gymState.status,
  //       address: `${gymState.address} ${detail}`
  //     });
  //     navigate(-2);
  //   } catch (err: any) {
  //     showToast({
  //       message: '수업 장소를 등록하는데 실패했습니다.',
  //       type: 'fail'
  //     });
  //   }
  // };

  // 안 쓰는 코드 주석 처리
  // type Inputs = {
  //   name: string;
  //   phoneNumber: number;
  //   detailAddress: string;
  //   endAt?: Date;
  //   detail: string;
  // };

  // 안 쓰는 코드 주석 처리
  // const { control, handleSubmit, watch, setValue } = useForm<Inputs>({
  //   mode: 'onSubmit'
  // });

  const [, setIsMyGym] = useState<boolean>(false);
  const [address, setAddress] = useState<string>('');

  const onAddressComplete = (addressData: { address: string }) => {
    setIsMyGym(false);
    setAddress(addressData.address);
    setAddressModalOpen(false);
  };

  const [addressModalOpen, setAddressModalOpen] = useState<boolean>(false);

  useEffect(() => {
    document.body.style.overflowY = addressModalOpen ? 'hidden' : 'auto';
  }, [onAddressComplete, addressModalOpen]);

  // 이미지 처리
  const [images, setImages] = useState<string[]>([]);

  const handleUploadFileComplete = (id: string) => {
    setImages(prevImages => [...prevImages, id]);
  };

  // 파일 삭제 완료 시 호출되는 함수
  const handleDeleteFileComplete = (id: string) => {
    setImages(prevImages => prevImages.filter(file => file !== id));
  };

  // 안 쓰는 코드 주석 처리
  // const handleClickGym = (gym: TGym) => {
  //   setGymState(gym);
  //   //navigate(PATH.ONBOARD_GYM);
  // };

  const { data: coordinatesData, isSuccess: coordinatesSuccess } =
    useGetCoordinates(address);

  const [coord, setCoord] = useState<{ x: string; y: string }>({
    x: '38.1677333',
    y: '128.5773073'
  });

  useEffect(() => {
    if (address && coordinatesSuccess && coordinatesData) {
      const { x, y } = coordinatesData.documents[0]?.road_address;
      setCoord({ x: y, y: x });
    }
  }, [address, coordinatesSuccess]);

  // ------------------- 공간 정보 추가 -----------------------------

  interface CheckListItem {
    id: string;
    description: string;
    checked: boolean;
    icons: JSX.Element;
  }

  const INITIAL_CHECKLIST = [
    {
      id: 'showerRoom',
      description: '샤워실',
      checked: false,
      icons: (
        <MdOutlineShower style={{ marginRight: 5, width: 17, height: 18 }} />
      )
    },
    {
      id: 'clothRoom',
      description: '탈의실',
      checked: false,
      icons: <PiCoatHanger style={{ marginRight: 5, width: 16, height: 18 }} />
    },
    {
      id: 'cloth',
      description: '운동복',
      checked: false,
      icons: <TbShirtFilled style={{ marginRight: 5, width: 16, height: 18 }} />
    },
    {
      id: 'cabinet',
      description: '사물함',
      checked: false,
      icons: (
        <MdScreenLockLandscape
          style={{ marginRight: 5, width: 16, height: 18 }}
        />
      )
    },
    {
      id: 'towel',
      description: '수건',
      checked: false,
      icons: <GiTowel style={{ marginRight: 5, width: 16, height: 18 }} />
    },
    {
      id: 'parking',
      description: '주차가능',
      checked: false,
      icons: (
        <MdDirectionsCar style={{ marginRight: 5, width: 16, height: 18 }} />
      )
    }
  ];
  const { setUserInfo } = useUserInfo();
  const [name, setName] = useState<string>('');
  const [detailAddress, setDetailAddress] = useState<string>('');
  const [phoneNum, setPhoneNum] = useState<string>('');
  const [detailInfo, setDtailInfo] = useState<string>('');
  const [checkList, setCheckList] =
    useState<CheckListItem[]>(INITIAL_CHECKLIST);

  // 안 쓰는 코드 주석 처리
  // const { state } = useLocation();

  // 안 쓰는 코드 주석 처리
  // const curLocation = state?.location || '';
  // const lat = state?.lat || 'default lat';
  // const lng = state?.lng || 'default lng';

  const submitSpaceRegApplication = async () => {
    try {
      const {
        showerRoom,
        parking,
        clothRoom,
        cloth,
        cabinet,
        towel
      }: Record<string, CheckListItem> = checkList.reduce(
        (prev, current) => ({ ...prev, [current.id]: current }),
        {}
      );

      const fullAddress = address + ' ' + detailAddress;
      const gymInfo: IPostGymSpaceRegistry = {
        name: name !== '' ? name : '123',
        introduction: detailInfo !== '' ? detailInfo : '123',
        phone: phoneNum !== '' ? phoneNum : '123',
        address: address !== '' ? address : '123',
        long: coord.x ?? '123',
        lat: coord.y ?? '123',
        showerRoom: showerRoom.checked ?? false,
        parkingSpace: parking.checked ?? false,
        locker: cabinet.checked ?? false,
        fittingRoom: clothRoom.checked ?? false,
        sportswear: cloth.checked ?? false,
        tower: towel.checked ?? false,
        images: images ?? ['0']
      };
      const res = await postGymSpaceRegister(gymInfo);
      // await postGymSpaceImgRegister(
      //   res.id,
      //   createImgToFormData(localBeforeImgs)
      // );
      // await postCoachGym(res.id).then(() =>
      //   getMyAccount().then(account => setUserInfo(account))
      // );
      await postCoachGym(res.id);
      setGymState(res);

      showToast({
        type: 'success',
        message: '수업 공간 등록에 성공하였습니다.'
      });
      navigate(-3);
    } catch {
      showToast({
        type: 'fail',
        message: '수업 공간 등록에 실패했습니다.'
      });
    }
  };

  const handleChipClick = (id: string) => {
    setCheckList(prevList =>
      prevList.map(item =>
        item.id === id ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const disabled =
    !address ||
    !name ||
    !phoneNum ||
    images.length === 0 ||
    checkList.every(item => !item.checked) ||
    isLoading;

  return (
    <PrevHeaderBarWithTitleTemplate
      title="수업 장소"
      hasBorder={false}
      ContainerStyle={{ position: 'relative' }}
      defaultBackground
      onPrevCallback={() => setGymState(null)}
      rightContents={
        <SaveText
          text="등록"
          disabled={disabled}
          onClick={submitSpaceRegApplication}
        />
      }
    >
      <Wrapper>
        <div>
          {address ? (
            <>
              <div />
              {/* <MapComponent
                  latitude={coord.x}
                  longitude={coord.y}
                ></MapComponent> */}
              <div style={{ position: 'relative' }}>
                <KakaoMap
                  latitude={Number(coord.x)}
                  longitude={Number(coord.y)}
                  MapContainerStyle={{
                    border: `1px solid ${theme.palette.gray600}`,
                    borderRadius: '8px',
                    height: '120px'
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    width: '89px',
                    height: '24px',
                    bottom: '8px',
                    right: '8px',
                    padding: '4px 10px',
                    borderRadius: '22px',
                    backgroundColor: '#18171C',
                    zIndex: 3
                  }}
                  onClick={() => {
                    setAddressModalOpen(true);
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'Pretendard Variable',
                      fontSize: '12px',
                      fontWeight: 500,
                      color: '#EAE8ED'
                    }}
                  >
                    주소 다시 검색
                  </div>
                </div>
              </div>

              {/* <KakaoMapContainer>
                  <div
                    id="map"
                    ref={mapRef}
                    style={{
                      border: `1px solid ${theme.palette.gray600}`,
                      borderRadius: '8px',
                      height: '120px'
                    }}
                  />
                </KakaoMapContainer> */}
              <Description color="white">
                {address ?? '주소를 검색해 주세요'}
              </Description>
              <LabeledInput
                value={detailAddress}
                onInput={value => setDetailAddress(value)}
                label={''}
                placeholder="세부 주소를 적어주세요"
              />
              <Wrapper2></Wrapper2>
            </>
          ) : (
            <>
              <EmptyMapContainer>
                <Button
                  onClick={() => {
                    setAddressModalOpen(true);
                  }}
                  style={{ backgroundColor: 'transparent' }}
                >
                  <MapTitle>
                    <IoSearchSharp color={theme.palette.brand300} />
                    <Strong>주소 검색</Strong>
                  </MapTitle>
                </Button>
              </EmptyMapContainer>
              <Description>{'주소를 검색해 주세요'}</Description>
            </>
          )}
          {addressModalOpen && (
            <AddressModal
              onComplete={onAddressComplete}
              onCancel={() => {
                setAddressModalOpen(false);
              }}
            />
          )}
          <Flex direction="column" gap={32}>
            <LabeledInput
              value={name}
              onInput={a => setName(a as string)}
              label={'장소명'}
              placeholder="장소명을 입력해 주세요"
              required
            />
            <LabeledInput
              value={phoneNum}
              onInput={value => setPhoneNum(value)}
              label={'전화번호'}
              placeholder="해당 장소의 전화번호를 입력해 주세요"
              required
            />
            <Flex direction="column" gap={8}>
              <Label>
                <div>
                  사진 업로드{' '}
                  <RequiredMark
                    style={{ fontSize: '16px', marginLeft: '-4px' }}
                  >
                    *
                  </RequiredMark>
                </div>
              </Label>
              <FileUpload
                maxCountMsg={'test'}
                path={'image'}
                fileType="image/*"
                // onChange={onChange}
                maxCount={5}
                onUploadFileComplete={handleUploadFileComplete}
                onDeleteFileComplete={handleDeleteFileComplete}
              >
                <ImageUpload />
              </FileUpload>
            </Flex>
            <Flex direction="column" gap={8}>
              <Label>
                <div>
                  편의 시설{' '}
                  <RequiredMark
                    style={{ fontSize: '16px', marginLeft: '-4px' }}
                  >
                    *
                  </RequiredMark>
                </div>
              </Label>
              <ChipContainer>
                {checkList.map(item => (
                  <Chip
                    key={item.id}
                    isSelected={item.checked}
                    onClick={() => handleChipClick(item.id)}
                    style={{
                      width: 'auto',
                      minWidth: 'auto'
                    }}
                  >
                    {item.icons}
                    {item.description}
                  </Chip>
                ))}
              </ChipContainer>
              {/* <CheckBoxContainer>
                  {checkList.map(item => (
                    <>
                      <LeftTextCheckBox
                        id={item.id}
                        label={item.description}
                        labelLocation="left"
                        onClick={() => handleCheckBox(item)}
                        checked={item.checked}
                      />
                    </>
                  ))}
                </CheckBoxContainer> */}
            </Flex>
            <Flex direction="column" gap={8}>
              <Label style={{ justifyContent: 'space-between' }}>
                추가 정보
                <InputLength
                  currentLength={detailInfo.length}
                  maxLength={500}
                />
              </Label>
              <TextareaContainer>
                <Textarea
                  value={detailInfo}
                  onChange={value => setDtailInfo(value)}
                  placeholder="수업장소에 대해 추가적으로 안내할 사항에 대해 작성해 주세요"
                  height={12.8}
                  limit={500}
                />
              </TextareaContainer>
            </Flex>
          </Flex>
        </div>
      </Wrapper>
    </PrevHeaderBarWithTitleTemplate>
  );
}
const Wrapper = styled.div`
  padding: 20px;
`;

const Wrapper2 = styled.div`
  padding: 20px;
`;

// 안 쓰는 코드 주석 처리
// const Info = styled(Flex)`
//   margin-top: 32px;
//   margin-bottom: 16px;
// `;

// const Title = styled.span`
//   font-size: 18px;
//   font-weight: 600;
//   color: ${({ theme }) => theme.palette.gray15};
// `;

// const Address = styled.span`
//   font-size: 14px;
//   color: ${({ theme }) => theme.palette.gray100};
// `;

const Description = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 10px;
  color: ${({ color, theme }) => color || theme.palette.gray300};
  white-space: pre-wrap;
`;

const EmptyMapContainer = styled.div`
  display: grid;
  place-items: center; /* 수평 및 수직 중앙 정렬 */
  height: 100vh; /* 부모 요소의 높이를 전체 화면 높이로 설정 */
  border: 1px solid ${({ theme }) => theme.palette.gray300};
  border-radius: 8px;
  height: 120px;
  text-align: center;
`;

const MapTitle = styled.span`
  display: flex; /* Flexbox 사용 */
  align-items: center; /* 수직 중앙 정렬 */
  gap: 2px; /* 아이템 간의 간격 설정 (선택적) */
  font-size: 14px;
  font-weight: 500;
  margin: center;
  color: ${({ theme }) => theme.palette.gray15};
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray25};
`;

const RequiredMark = styled.div`
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  margin-left: auto;
  color: ${({ theme }) => theme.palette.brand300};
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* 칩 사이의 간격 조정 */
  max-width: 360px; /* 전체 너비 조정 (3개가 한 줄에 배치될 수 있는 최대 너비) */
`;

const Chip = styled.div<{ isSelected: boolean }>`
  display: flex; /* 변경: inline-flex 대신 flex 사용 */
  align-items: center;
  justify-content: center; /* 중앙 정렬 */
  padding: 6px 10px; /* 패딩 조정 */
  margin: 4px;
  border-radius: 16px;
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.palette.brand400}`
      : `1px solid ${theme.palette.gray600}`};
  background-color: ${({ theme }) => theme.palette.gray800};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.palette.brand300 : theme.palette.gray25};
  cursor: pointer;
  user-select: none;
  transition:
    background-color 0.3s,
    color 0.3s;
  width: 96px; /* 자동 너비 조정 */
  min-width: 100px; /* 최소 너비 설정 */
  text-align: center; /* 텍스트 중앙 정렬 */
  box-sizing: border-box; /* 패딩과 보더를 너비에 포함 */
`;

const TextareaContainer = styled.div`
  padding: 1rem 0;
  p {
    margin-bottom: 1rem;
  }
`;

// 안 쓰는 코드 주석 처리
// const CheckBoxContainer = styled.div`
//   padding: 0 0 1rem;
//   > div:first-child {
//     padding-top: 0;
//   }
// `;
